import React from 'react'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import BusinessAnalysis from '../assets/productsimages/Business Analysis.png'

const Products = () => {
    const products = [
        {
            id: 1,
            title: "Free Business Analysis",
            description: "Complimentary assessment of your business operations and financial strategy",
            src: BusinessAnalysis,
            path: '/business-analysis'
        },
    ]

    return (
        <motion.div 
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 2 }}
            name='Products' 
            className='bg-gradient-to-b from-white to-white w-full text-black min-h-screen py-32 mt-96 mb-32 sm:mb-0 sm:mt-0 sm:py-20'
        >
            <div className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full'>
                <motion.div 
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 2 }}
                    className='pb-16 text-center'
                >
                    <p className='text-4xl font-bold inline border-b-4 border-black'>Products</p>
                    <p className='mt-6 text-lg max-w-2xl mx-auto text-black'>
                        Initial assesment of operations, financial strategy, and growth potential for companies.
                    </p>
                </motion.div>

                {/* Modified to center a single product */}
                <div className='flex justify-center w-full'>
                    <div className='flex justify-center w-full px-4 sm:px-0 mb-16 sm:mb-0'>
                        {products.map(({id, title, description, src, path}, index) => (
                            <motion.div 
                                key={id}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 1.2, delay: index * 1.2 }}
                                className='flex flex-col items-center max-w-md'
                            >
                                <Link 
                                    to={path}
                                    onClick={() => window.scrollTo(0, 0)}
                                    className="w-full mb-6 flex justify-center"
                                >
                                    <div className="rounded-lg overflow-hidden transition-all duration-500">
                                        <img 
                                            src={src} 
                                            alt={title} 
                                            className='w-full h-64 object-contain transition-transform duration-1000' 
                                        />
                                    </div>
                                </Link>
                                
                                <div className="text-center">
                                    <h3 className="text-2xl font-semibold mb-3">{title}</h3>
                                    <p className="text-gray-600 mb-4">{description}</p>
                                    <Link 
                                        to={path}
                                        onClick={() => window.scrollTo(0, 0)}
                                    >
                                        <span className="inline-block px-5 py-2 bg-gray-100 hover:bg-gray-200 rounded-md text-black font-medium transition-colors duration-500">
                                            Learn More
                                        </span>
                                    </Link>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </motion.div>
    )
}

export default Products
